import { fmtDate } from "./api";

const rs = (n) => "₹" + Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 });

export function buildDayMessage(day) {
  const books = {};
  day.entries.forEach((e) => {
    const b = (books[e.site_name] ||= { deposit: 0, withdraw: 0 });
    b[e.type] += e.amount;
  });
  const lines = [`*Daily Summary – ${fmtDate(day.date)}*`, ""];
  Object.entries(books).forEach(([name, b]) => {
    lines.push(`*${name}*`, `  Deposit: ${rs(b.deposit)}`, `  Withdraw: ${rs(b.withdraw)}`, "");
  });
  if (!day.entries.length) lines.push("No entries today.", "");
  lines.push(`*Total Deposit:* ${rs(day.total_deposit)}`, `*Total Withdraw:* ${rs(day.total_withdraw)}`, `*Net:* ${rs(day.balance)}`);
  return lines.join("\n");
}

export const waUrl = (text) => `https://wa.me/?text=${encodeURIComponent(text)}`;

export const shareWhatsApp = (text) => window.open(waUrl(text), "_blank", "noopener");
